<template>
  <div class="right_col" role="main">
    <div class="">
      <div class="page-title">
        <div class="title_left">
          <h3>
            {{ title }}
            <span v-if="isConfirmView"
              >- {{ $t('orderPage.inputConfirmation') }}</span
            >
          </h3>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div class="x_panel">
            <div class="x_content form-horizontal form-label-left">
              <alert
                :title="title"
                :success-message="$t('common.isSuccess')"
                :error-message="$t('common.isFailure')"
                :alerts="alerts"
                :errors="errors"
                :display="alertDisplay"
                @closeAlert="closeAlert"
              />
              <div v-if="!isUs" class="form-group">
                <label
                  class="control-label col-md-2 col-sm-2 col-xs-12"
                  style="padding-right: 0"
                >
                  {{ $t('common.categoryName') }}：
                </label>
                <label
                  class="control-label col-md-1 col-sm-2 col-xs-12"
                  for="nameJa"
                  style="padding-left: 0"
                >
                  {{ $t('orderPage.japanese') }}：
                  <span v-if="isJp || isTw || isCn" class="required">*</span>
                </label>
                <div class="form-group col-md-5 col-sm-5 col-xs-12">
                  <input
                    id="nameJa"
                    v-model="names.ja"
                    v-validate="ValidRules.nameJa"
                    :data-vv-as="$t('common.categoryNameJapanese')"
                    :placeholder="$t('common.categoryName')"
                    :disabled="isConfirmView"
                    type="text"
                    name="nameJa"
                    class="form-control"
                  />
                  <div
                    v-show="validator.has('nameJa')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('nameJa')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label
                  v-if="isUs"
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                >
                  {{ $t('common.categoryName') }}：<span class="required"
                    >*</span
                  >
                </label>
                <label
                  v-if="!isUs"
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  for="nameUs"
                >
                  {{ $t('orderPage.english') }}：
                  <span v-if="isJp || isTw || isUs || isCn" class="required"
                    >*</span
                  >
                </label>
                <div class="form-group col-md-5 col-sm-5 col-xs-12">
                  <input
                    id="nameUs"
                    v-model="names.us"
                    v-validate="ValidRules.nameUs"
                    :data-vv-as="$t('common.categoryNameEnglish')"
                    :disabled="isConfirmView"
                    type="text"
                    name="nameUs"
                    class="form-control"
                    placeholder="Category name"
                  />
                  <div
                    v-show="validator.has('nameUs')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('nameUs')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div v-if="!isUs && !isCn" class="form-group">
                <label
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  for="nameZhTw"
                >
                  {{ $t('orderPage.traditionalChinese') }}：
                  <span v-if="isJp || isTw" class="required">*</span>
                </label>
                <div class="form-group col-md-5 col-sm-5 col-xs-12">
                  <input
                    id="nameZhTw"
                    v-model="names['zh-tw']"
                    v-validate="ValidRules.nameZhTw"
                    :data-vv-as="$t('common.categoryNameTraditionalChinese')"
                    :disabled="isConfirmView"
                    type="text"
                    name="nameZhTw"
                    class="form-control"
                    placeholder="類別名稱"
                  />
                  <div
                    v-show="validator.has('nameZhTw')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect(
                          'nameZhTw'
                        )"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div v-if="!(isUs || isTw)" class="form-group">
                <label
                  class="control-label col-md-3 col-sm-3 col-xs-12"
                  for="nameZhCn"
                >
                  {{ $t('orderPage.simplifiedChinese') }}：
                  <span v-if="isJp || isCn" class="required">*</span>
                </label>
                <div class="form-group col-md-5 col-sm-5 col-xs-12">
                  <input
                    id="nameZhCn"
                    v-model="names['zh-cn']"
                    v-validate="ValidRules.nameZhCn"
                    :data-vv-as="$t('common.categoryNameSimplifiedChinese')"
                    :disabled="isConfirmView"
                    type="text"
                    name="nameZhCn"
                    class="form-control"
                    placeholder="类别名称"
                  />
                  <div
                    v-show="validator.has('nameZhCn')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect(
                          'nameZhCn'
                        )"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div v-if="!(isUs || isTw || isCn)" class="form-group">
                <label
                  class="control-label col-md-3 col-sm-5 col-xs-12"
                  for="nameKr"
                >
                  {{ $t('orderPage.korean') }}：
                  <span v-if="isJp" class="required">*</span>
                </label>
                <div class="form-group col-md-5 col-sm-5 col-xs-12">
                  <input
                    id="nameKr"
                    v-model="names.kr"
                    v-validate="ValidRules.nameKr"
                    :data-vv-as="$t('common.categoryNameKorean')"
                    :disabled="isConfirmView"
                    type="text"
                    name="nameKr"
                    class="form-control"
                    placeholder="카테고리 이름"
                  />
                  <div
                    v-show="validator.has('nameKr')"
                    class="alert alert-danger"
                    role="validater"
                  >
                    <ul>
                      <li
                        v-for="(message, index) in validator.collect('nameKr')"
                        :key="index"
                      >
                        {{ message }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="ln_solid"></div>
              <div class="form-group">
                <div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3">
                  <span @click="back()" class="btn btn-default">{{
                    $t('common.back')
                  }}</span>
                  <span
                    v-if="!isConfirmView"
                    @click="confirm"
                    class="btn btn-success"
                    >{{ $t('common.inputComplete') }}</span
                  >
                  <span v-else @click="submit" class="btn btn-success">{{
                    $t('orderPage.registration')
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Alert from '@/components/common/alert/Alert'
import { mapGetters } from 'vuex'
import CategoryRequest from '@/http/CategoryRequest'
import ValidRules from '@/validator/CategoryRules'
import alert from '@/mixin/alert'
export default {
  components: {
    Alert,
  },
  mixins: [alert],
  data() {
    return {
      title: this.$t('orderPage.categoryInformationRegistration'),
      names: {
        ja: '',
        us: '',
        'zh-tw': '',
        'zh-cn': '',
        kr: '',
      },
      isEdit: false,
      isConfirmView: false,
      ValidRules: ValidRules,
    }
  },
  computed: {
    ...mapGetters({
      getCategoryById: 'category/getCategoryById',
    }),
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isJp() {
      return this.defaultLanguage === 'ja'
    },
    isUs() {
      return this.defaultLanguage === 'us'
    },
    isTw() {
      return this.defaultLanguage === 'zh-tw'
    },
    isCn() {
      return this.defaultLanguage === 'zh-cn'
    },
  },
  mounted() {
    if (this.$route.name === 'categoryEdit') {
      this.isEdit = true
      this.title = this.$t('orderPage.editCategoryInformation')
      this.getStoreData(this.$route.params.id)
    }
  },
  methods: {
    getStoreData: function(id) {
      const storeData = this.getCategoryById(id)
      this.names.ja = storeData.names.ja
      this.names.us = storeData.names.us
      this.names['zh-tw'] = storeData.names['zh-tw']
      this.names['zh-cn'] = storeData.names['zh-cn']
      this.names.kr = storeData.names.kr
    },
    back: function() {
      if (this.isConfirmView) {
        this.isConfirmView = false
      } else {
        this.$router.push({ name: 'category' })
      }
    },
    confirm: function() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.isConfirmView = true
        }
      })
    },
    submit: function() {
      const request = new CategoryRequest()
      const nameList = [
        { languageCode: 'ja', name: this.names.ja },
        { languageCode: 'us', name: this.names.us },
        { languageCode: 'zh-tw', name: this.names['zh-tw'] },
        { languageCode: 'zh-cn', name: this.names['zh-cn'] },
        { languageCode: 'kr', name: this.names.kr },
      ]

      const params = {
        nameList: nameList.filter((nameObj) => nameObj.name),
      }

      if (this.isEdit) {
        // 更新
        request
          .update(this.$route.params.id, params)
          .then(() => {
            this.$router.push({
              name: 'category',
              params: { succeeded: true, title: this.title },
            })
          })
          .catch((err) => {
            this.isConfirmView = false
            this.openErrorAlert(err.response.data)
            console.log(err.response)
          })
      } else {
        // 新規登録
        request
          .insert(params)
          .then(() => {
            this.$router.push({
              name: 'category',
              params: { succeeded: true, title: this.title },
            })
          })
          .catch((err) => {
            this.isConfirmView = false
            this.openErrorAlert(err.response.data)
            console.log(err.response)
          })
      }
    },
  },
}
</script>
